import { render, staticRenderFns } from "./DirectAccessError.vue?vue&type=template&id=1f9c6690&scoped=true&"
import script from "./DirectAccessError.vue?vue&type=script&lang=ts&"
export * from "./DirectAccessError.vue?vue&type=script&lang=ts&"
import style0 from "./DirectAccessError.vue?vue&type=style&index=0&id=1f9c6690&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f9c6690",
  null
  
)

export default component.exports